import React from 'react';
import './About.css'
import CopyPeople from '../CopyPeopleList/CopyPeople'
import TopTraded from '../TopTraded/TopTraded'

const About = (props) => {
    const profiles = [
        {
            name: "David James",
            region: "United Arab Emirates",
            risk: 5,
            return: 7.14,
            image: "https://st.depositphotos.com/2218212/2938/i/450/depositphotos_29387653-stock-photo-facebook-profile.jpg",
            copiers: 1356,
            copyPercentage: -2.21,
            type: "Top Investors"
        },
        {
            name: "David James",
            region: "United Arab Emirates",
            risk: 5,
            return: 7.14,
            image: "https://st.depositphotos.com/2218212/2938/i/450/depositphotos_29387653-stock-photo-facebook-profile.jpg",
            copiers: 1356,
            copyPercentage: -2.21,
            type: "Top Investors"
        },
        {
            name: "David James",
            region: "United Arab Emirates",
            risk: 5,
            return: 7.14,
            image: "https://st.depositphotos.com/2218212/2938/i/450/depositphotos_29387653-stock-photo-facebook-profile.jpg",
            copiers: 1356,
            copyPercentage: -2.21,
            type: "Top Investors"
        },

        {
            name: "David James",
            region: "United Arab Emirates",
            risk: 5,
            return: 7.14,
            image: "https://st.depositphotos.com/2218212/2938/i/450/depositphotos_29387653-stock-photo-facebook-profile.jpg",
            copiers: 1356,
            copyPercentage: -2.21,
            type: "Top Investors"
        },
        {
            name: "Emma Thompson",
            region: "United Kingdom",
            risk: 3,
            return: 5.25,
            image: "https://st.depositphotos.com/2218212/2938/i/450/depositphotos_29387653-stock-photo-facebook-profile.jpg",
            copiers: 845,
            copyPercentage: 1.35,
            type: "Trending"
        },

        {
            name: "Emma Thompson",
            region: "United Kingdom",
            risk: 7,
            return: 5.25,
            image: "https://st.depositphotos.com/2218212/2938/i/450/depositphotos_29387653-stock-photo-facebook-profile.jpg",
            copiers: 845,
            copyPercentage: 1.35,
            type: "Low Risk Score"
        },
        {
            name: "Emma Thompson",
            region: "United Kingdom",
            risk: 7,
            return: 5.25,
            image: "https://st.depositphotos.com/2218212/2938/i/450/depositphotos_29387653-stock-photo-facebook-profile.jpg",
            copiers: 845,
            copyPercentage: 1.35,
            type: "Low Risk Score"
        },
        {
            name: "Emma Thompson",
            region: "United Kingdom",
            risk: 7,
            return: 5.25,
            image: "https://st.depositphotos.com/2218212/2938/i/450/depositphotos_29387653-stock-photo-facebook-profile.jpg",
            copiers: 845,
            copyPercentage: 1.35,
            type: "Low Risk Score"
        },
        {
            name: "Emma Thompson",
            region: "United Kingdom",
            risk: 7,
            return: 5.25,
            image: "https://st.depositphotos.com/2218212/2938/i/450/depositphotos_29387653-stock-photo-facebook-profile.jpg",
            copiers: 845,
            copyPercentage: 1.35,
            type: "Low Risk Score"
        },

        {
            name: "Emma Thompson",
            region: "United Kingdom",
            risk: 7,
            return: 5.25,
            image: "https://st.depositphotos.com/2218212/2938/i/450/depositphotos_29387653-stock-photo-facebook-profile.jpg",
            copiers: 845,
            copyPercentage: 1.35,
            type: "Low Risk Score"
        },
        {
            name: "Emma Thompson",
            region: "United Kingdom",
            risk: 7,
            return: 5.25,
            image: "https://st.depositphotos.com/2218212/2938/i/450/depositphotos_29387653-stock-photo-facebook-profile.jpg",
            copiers: 845,
            copyPercentage: 1.35,
            type: "Medium Risk Score"
        },
        {
            name: "Emma Thompson",
            region: "United Kingdom",
            risk: 7,
            return: 5.25,
            image: "https://st.depositphotos.com/2218212/2938/i/450/depositphotos_29387653-stock-photo-facebook-profile.jpg",
            copiers: 845,
            copyPercentage: 1.35,
            type: "Medium Risk Score"
        },
    ];
    return (
        <>
            <div style={{ display: "flex", width: "100%", padding: "12px", overflowY: "auto", height: "100%" }}>
                <div className='divAbout-container'>
                    <div className='container-BioBox'>
                        <label className='lableCustomized'>Biography</label>
                        <div style={{ padding: "0px 10px 10px 10px" }}>
                            Dear investors, Hi! <br />
                            Professional Fund Manager for more than 20 years. I am the most copied Popular investor specialized in Forex trading
                            This low risk strategy aims consistent positive returns (40 months in a row since inception) with strict money management rules. My target is 1% per month. I monitor currency pairs all day to find the best entry. There is some management/scaling position for perfect entry. The risk control is a big part of my strategy, I take care a lot of my copiers' funds that I consider like mine.
                        </div>
                    </div>
                    <div className='container-TopTradeBox'>
                        <label className='lableCustomized'>Top Traded</label>
                        <div style={{ padding: "0px 10px 10px 10px" }}>
                            <TopTraded />
                        </div>
                    </div>
                </div>
                <div className='container-SimilarTradersBox'>
                    <label className='lableCustomized'>Similar Traders</label>
                    <div style={{ padding: "0px 10px 10px 10px", display: "flex", flexWrap: "wrap" }}>

                        {profiles
                            .filter(profile => profile.type === "Top Investors")
                            .map((profile, index) => (
                                <CopyPeople
                                    key={index}
                                    profile={profile}
                                    isDarkMode={props.isDarkMode}
                                />
                            ))}
                    </div>
                </div>
            </div >


        </>
    );
};

export default About;